import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/images/slanted_white_arrow.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-5 h-5",
  alt: "slantedWhiteArrow"
}, null, -1)

import { computed } from 'vue'
import Sidebar from '@/components/Sidebar.vue'
import Records from './Records.vue'
import { isProd } from '@/constants'
import { useStore } from '@/store'
import TitleArea from '@/components/TitleArea.vue'
interface Props {
  visible: boolean
  title:string
}
interface Emits {
  (e:'close'):void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: null,
    title: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e:'close'):void
}), expose: any, slots: any, attrs: any }) {



const store = useStore()
const account = computed(() => store.state.account)
const toAccountEverScan = () => {
  if (account.value) {
    window.open(`https://scan${isProd ? '' : '-dev'}.everpay.io/account/${account.value}`)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Sidebar, {
      visible: __props.visible,
      title: __props.title,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
    }, {
      title: _withCtx(() => [
        _createVNode(TitleArea, {
          class: "border-b border-white border-opacity-10 cursor-pointer",
          onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "flex items-center",
              onClick: toAccountEverScan
            }, [
              _createTextVNode(_toDisplayString(__props.title) + " ", 1),
              _hoisted_1
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(Records, { visible: __props.visible }, null, 8, ["visible"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})